import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  customers: 'Customers',
  VIN: 'VIN',
  texasCashCard: 'TexasCashCard',
  supplierType: 'SupplierType',
  vendorClass: 'VendorClass',
  customerInvoices: 'CustomerInvoices',
  inboundTickets: 'InboundTickets',
  drivers: 'drivers',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [
    TAG_TYPES.customers,
    TAG_TYPES.VIN,
    TAG_TYPES.texasCashCard,
    TAG_TYPES.supplierType,
    TAG_TYPES.vendorClass,
    TAG_TYPES.customerInvoices,
  ],
  endpoints: {
    getCustomers: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(customer => ({
                type: TAG_TYPES.customers,
                id: customer.id,
              })),
              { type: TAG_TYPES.customers, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Customers', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.customers, id: 'LIST' }],
    },
    getCustomer: {
      providesTags: (result, error, { customerId }) => [{ type: TAG_TYPES.customers, id: customerId }],
    },
    createCustomer: {
      invalidatesTags: [{ type: TAG_TYPES.customers, id: 'LIST' }],
    },
    updateCustomer: {
      invalidatesTags: (result, error, { customerId }) => [
        { type: TAG_TYPES.customers, id: customerId },
        { type: TAG_TYPES.drivers, id: 'LIST' },
      ],
    },
    archiveCustomer: {
      invalidatesTags: (result, error, { customerId }) => [
        { type: TAG_TYPES.customers, id: customerId },
        { type: TAG_TYPES.customers, id: 'LIST' },
      ],
    },
    patchCustomer: {
      invalidatesTags: () => [{ type: TAG_TYPES.customers, id: 'LIST' }],
    },
    deleteCustomerLocation: {
      invalidatesTags: (_result, _error, { customerId }) => [{ type: TAG_TYPES.customers, id: customerId }],
    },
    getVehicleInfoFromVin: {
      providesTags: (result, error, { vin }) => [{ type: TAG_TYPES.VIN, id: vin }],
    },
    getTexasCashCard: {
      providesTags: (result, error, { contactId }) => [{ type: TAG_TYPES.texasCashCard, id: contactId }],
    },
    createTexasCashCard: {
      invalidatesTags: (result, error, { contactId, customerId }) => [
        { type: TAG_TYPES.texasCashCard, id: contactId },
        { type: TAG_TYPES.customers, id: customerId },
      ],
    },
    getSupplierTypes: {
      providesTags: [{ type: TAG_TYPES.supplierType, id: 'LIST' }],
    },
    createSupplierType: {
      invalidatesTags: [{ type: TAG_TYPES.supplierType, id: 'LIST' }],
    },
    patchSupplierType: {
      invalidatesTags: [{ type: TAG_TYPES.supplierType, id: 'LIST' }],
    },
    getVendorClasses: {
      providesTags: [{ type: TAG_TYPES.vendorClass, id: 'LIST' }],
    },
    createVendorClass: {
      invalidatesTags: [{ type: TAG_TYPES.vendorClass, id: 'LIST' }],
    },
    patchVendorClass: {
      invalidatesTags: [{ type: TAG_TYPES.vendorClass, id: 'LIST' }],
    },
    checkBuyEligibility: {},
    getCustomerInvoices: {
      providesTags: (result, error, { customerId }) => [
        { type: TAG_TYPES.customerInvoices, id: customerId },
        { type: TAG_TYPES.customers, id: customerId },
      ],
    },
    getCustomerMaterialPurchasePriceHistory: {
      providesTags: [{ type: TAG_TYPES.inboundTickets, id: 'LIST' }], // invalidated when IBT is updated
    },
    inviteContactToPortal: {
      invalidatesTags: (result, error, { customerId }) => [{ type: TAG_TYPES.customers, id: customerId }],
    },
  },
})

export const useGetCustomersLazyQuery = api.endpoints.getCustomers.useLazyQuery
export const {
  useGetCustomersQuery,
  useGetCustomerQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useGetVehicleInfoFromVinQuery,
  usePatchCustomerMutation,
  useArchiveCustomerMutation,
  useDeleteCustomerLocationMutation,
  useGetTexasCashCardQuery,
  useCreateTexasCashCardMutation,
  useGetSupplierTypesQuery,
  useCreateSupplierTypeMutation,
  usePatchSupplierTypeMutation,
  useGetVendorClassesQuery,
  useCreateVendorClassMutation,
  usePatchVendorClassMutation,
  useCheckBuyEligibilityMutation,
  useGetCustomerInvoicesQuery,
  useGetCustomerMaterialPurchasePriceHistoryQuery,
  useInviteContactToPortalMutation,
} = api
